type Unite = "pourcentage-ca" | "fixe";

export const getValeurBonusUnite = (type: Unite): string => {
  switch (type) {
    case "pourcentage-ca":
      return "%";
    case "fixe":
      return "€";
    default:
      return "";
  }
};
